import _extends from "@babel/runtime-corejs2/helpers/extends";
import React from "react";
import { useLabelsFromAPI } from '@dmi-mch/hooks'; // this HOC will be used to import the labels from the api in class components.
// We need to pass the entityId from the component itself
// entityId is the label object which is needed for a specific page.

function withLabelsFromApi(Component, entityId) {
  return function WrappedComponent(props) {
    var _useLabelsFromAPI = useLabelsFromAPI(entityId),
        labels = _useLabelsFromAPI.labels;

    return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
      apiLabels: labels
    }));
  };
}

export default withLabelsFromApi;